/**
 * @ngdoc filters
 * @memberof mercury.filters
 * @name cleandecimal
 * @description This filter allows a numeric value to be displayed rounded to a
 * specified maximum number of decimal points, and without any trailing zeros.
 * E.g. "12.34567 | cleandecimal : 3" will produce "12.346", while
 * "12.00000 | cleandecimal : 3" will produce "12".
 */
angular.module('mercury.filters.cleandecimal', [])
.filter('cleandecimal', function() {
  return function(num, precision) {
    if (num == null) {
      return '';
    }

    if (precision == null) {
      precision = 0;
    }

    // We implemting the cleanup by shifting the decimal point of the number
    // 'precision' places  to the left by multiplying by the appropriate power
    // of 10, then round this value to an integer. This leaves us with a value
    // which when the decimal point is shifted back to the right by dividing by
    // the same power of 10 will have the right number of decimal places.
    return (
      Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision)
    ).toString();
  };
});
